
export default {
  name: 'ContactForm',
  props: ['document'],
  data() {
    return {
      form: {
        email: '',
        name: '',
        company: '',
        subject: '',
        requestType: '',
        message: '',
        conversation: '',
        privacyAcceptance: false,
        recipient: '',
        user_id: '',
        device_os: '',
        device_model: '',
        app_type: '',
        app_version: '',
        priority: 'Medium',
      },
      formErrors: {
        email: false,
        subject: false,
        name: false,
        company: false,
        requestType: false,
        message: false,
        privacyAcceptance: false,
        recipient: false
      },
      submitSuccess: false,
      submitError: false,
      isDisabled: false,
      faq: []
    }
  },
  computed: { 
    isSupportRequest(){
      return this.form.recipient === 'support@vitesy.com' ? true : false
    }
  },
  mounted() {
    this.$route.query.submit ? this.submitSuccess = true : ''
    this.$route.query.email ? this.form.email = this.$route.query.email : ''
    this.$route.query.full_name ? this.form.name = this.$route.query.full_name : ''
    this.$route.query.app ? this.form.requestType = 'tech_assistance' : ''
    this.$route.query.user_id ? this.form.user_id = this.$route.query.user_id : ''
    this.$route.query.device_os ? this.form.device_os = this.$route.query.device_os : ''
    this.$route.query.device_model ? this.form.device_model = this.$route.query.device_model : ''
    this.$route.query.app_type ? this.form.app_type = this.$route.query.app_type : ''
    this.$route.query.app_version ? this.form.app_version = this.$route.query.app_version : ''
    this.form.conversation = `User ID: ${this.form.user_id}\nDevice OS: ${this.form.device_os}\nDevice Model: ${this.form.device_model}\nApp Type: ${this.form.app_type}\nApp Version: ${this.form.app_version}`
    this.setRecipient()
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join('&')
    },
    setRecipient() {
      if (this.form.requestType === 'press') {
        this.form.recipient = 'press@vitesy.com'
      } else if (this.form.requestType === 'sales') {
        this.form.recipient = 'sales@vitesy.com'
      } else if (this.form.requestType === 'cv') {
        this.form.recipient = 'cv@vitesy.com'
      } else {
        this.form.recipient = 'support@vitesy.com'
      }
    },
    validateForm() {
      const emailRegexp = /\S+@\S+\.\S+/
      this.form.email.length &&
      emailRegexp.test(String(this.form.email).toLowerCase())
        ? (this.formErrors.email = false)
        : (this.formErrors.email = true)
      this.form.requestType.length
        ? (this.formErrors.requestType = false)
        : (this.formErrors.requestType = true)
      this.form.message.length
        ? (this.formErrors.message = false)
        : (this.formErrors.message = true)
      this.form.privacyAcceptance
        ? (this.formErrors.privacyAcceptance = false)
        : (this.formErrors.privacyAcceptance = true)
    },
    submitForm() {
      this.submitSuccess = false
      this.submitError = false
      this.validateForm()
      this.isDisabled = true
      if (Object.keys(this.formErrors).every(k => !this.formErrors[k])) {
        this.$axios
          .post('https://vitesy.com/', this.encode({'form-name': 'contact-form', ...this.form }), { header: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          .then(() => {
            this.submitSuccess = true
            this.form = {
              email: '',
              name: '',
              subject: '',
              company: '',
              requestType: '',
              message: '',
              conversation: '',
              recipient: '',
              privacy: false,
              user_id: '',
              device_os: '',
              device_model: '',
              app_type: '',
              app_version: ''
            }
            this.isDisabled = false
          })
          .catch(() => {
            this.submitError = true
            this.isDisabled = false
          })
      } else {
        this.submitError = true
        this.isDisabled = false
      }
    },
    async searchFAQ() {
      this.faq = []
        if (this.form.message.length > 10) {
          const lang = this.$i18n.locales.filter((i) =>
            i.iso.includes(this.$i18n.locale)
          )[0].iso
          try {
            const faq = await this.$prismic.api.query(
              [
                this.$prismic.predicates.at('document.type', 'faq'),
                this.$prismic.predicates.fulltext('document', this.form.message),
              ],
              { lang }
            )
            this.faq = faq.results.slice(0,5)
          } catch (e) {
            this.faq = []
          }
        }
    }
  },
}
